import AutoLockAction from "@/enum/AutoLockAction";
import mainServerClient from "@/services/http/mainServerClient";

export interface UndeliverableArea {
    id: number;
    displayIncludedAreas: string[];
    enable: boolean;
    autoAction?: AutoLockAction;
    excludedCities: string;
    excludedDistricts: string;
    includedAreas: string;
    includedProvinces: string;
    name: string;
    companyId: number;
    shopIds?: number[];
}

/**
 * 获取单个不可送达区域的信息
 */
export function getUndeliverableArea(id: number) {
    return mainServerClient.get<UndeliverableArea>("/undeliverable_area/get", {
        id,
    });
}

export interface SaveUndeliverableAreaParams {
    id?: number;
    enable: boolean;
    excludedCities?: string;
    excludedDistricts?: string;
    includedAreas?: string;
    includedProvinces?: string;
    name: string;
    autoAction: AutoLockAction;
}

/**
 * 保存单个不可送达区域的信息
 */
export function saveUndeliverableArea(params: SaveUndeliverableAreaParams) {
    return mainServerClient.post("/undeliverable_area/save", params);
}

/**
 * 删除单个不可送达区域的信息
 */
export function deleteUndeliverableArea(id: number) {
    return mainServerClient.post("/undeliverable_area/delete", {
        id,
    });
}

/**
 * 列出当前company的不可派送地址
 */
export function getUndeliverableAreaList() {
    return mainServerClient.get<UndeliverableArea[]>("/undeliverable_area/list");
}

/**
 * 切换启用状态
 */
export function changeEnableUndeliverableArea(id: number, enable: boolean) {
    return mainServerClient.post("/undeliverable_area/change_enable", {
        id,
        enable,
    });
}

/** 开启/关闭锁单功能 */
export function changeUnDeliverableAreaAutoAction(id: number, action: AutoLockAction) {
    return mainServerClient.post("/undeliverable_area/change_auto_action", { id, action });
}

interface ImportUndeliverableAreaExcelParams {
    autoAction: AutoLockAction;
    enable: boolean;
    name: string;
    file: File;
}

export interface ErrorInfoImportUndeliverableArea {
    cause: string;
    content: string;
    errorColumn: number;
    errorLine: number;
}

export interface ImportUndeliverableAreaExcelResult {
    errorInfos: ErrorInfoImportUndeliverableArea[];

    undeliverableArea: UndeliverableArea;

    failNum: number;

    successNum: number;
}

export function importUndeliverableAreaExcel(
    params: ImportUndeliverableAreaExcelParams,
): Promise<ImportUndeliverableAreaExcelResult> {
    const { autoAction, enable, name, file } = params;

    const formData = new FormData();

    formData.append("name", name);
    formData.append("file", file);
    formData.append("autoAction", autoAction);
    formData.append("enable", enable);

    return mainServerClient.post("/undeliverable_area/import", formData, { timeout: 60000 });
}

interface QnImportUndeliverableAreaExcelParams extends Omit<ImportUndeliverableAreaExcelParams, "file"> {
    excelFileOriginalName: string;
    excelFileSize: number;
    excelFileUrl: string;
}

export function qnImportUndeliverableAreaExcel(
    params: QnImportUndeliverableAreaExcelParams,
): Promise<ImportUndeliverableAreaExcelResult> {
    return mainServerClient.post("/undeliverable_area/qianniu/import", params);
}

export function updateUndeliverableEffectShop(id: number, shopIds: number[]) {
    return mainServerClient.post("/undeliverable_area/affect_shop", { id, shopIds });
}
